import { Component } from '@angular/core';
import { CmsService } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { switchMap, combineLatest, distinctUntilChanged, map, Observable, tap } from 'rxjs';
import { CMSAbstractGrid, CMSAbstractGridEntry } from './core/abstract-grid.model';

@Component({
  selector: 'app-cms-abstract-grid',
  templateUrl: './cms-abstract-grid.component.html',
  styleUrl: './cms-abstract-grid.component.scss',
  standalone: false,
})
export class CmsAbstractGridComponent {
  data$?: CMSAbstractGrid;

  components$: Observable<CMSAbstractGridEntry[]> = this.componentData.data$.pipe(
    tap((data: CMSAbstractGrid) => {
      this.data$ = data;
    }),
    switchMap((data: CMSAbstractGrid) =>
      combineLatest(
        (data?.items ?? '').split(' ').map((item: string) =>
          this.cmsService.getComponentData<any>(item).pipe(
            distinctUntilChanged(),
            map(item => {
              return item;
            }),
          ),
        ),
      ),
    ),
  );

  constructor(
    public componentData: CmsComponentData<any>,
    protected cmsService: CmsService,
  ) {}

  getFlexBasis(columnsPerRow: number): string {
    const columnWidth = (100 / columnsPerRow).toFixed(2);
    const gap = 'calc(var(--cx-grid-col-gutter) * 2)';
    const columns = columnsPerRow;
    const flexBasis = `calc(${columnWidth}% - (${gap} * ((${columns} - 1) / ${columns})))`;

    return flexBasis;
  }
}
